module.exports = __webpack_public_path__ + "img/scroll_up.33a8c382.svg";